import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {NEVER, EMPTY, Observable, throwError, of} from "rxjs";
import {DxLogger} from "../services/dx-logger.service";
import {DxModalService} from "../../dx-modals/services/dx-modal.service";
import {catchError} from "rxjs/operators";
import {Router} from "@angular/router";
import {DxHttpDispatcher} from "../services/dx-http-dispatcher.service";
import {DxObjectMapper} from "../services/dx-object-mapper.service";
import {ClientHandlerExtra} from "../domain/http/client-handler-extra";


/**
 * Перехватчик http-запросов, глобально обрабатывающий определённые ошибки.
 * @publicApi
 */
@Injectable()
export class DxHttpErrorInterceptor implements HttpInterceptor {


  /**
   * Создает инстанс логгирующего перехватчика.
   */
  constructor(private _logger: DxLogger,
              private _router: Router,
              private _http: DxHttpDispatcher,
              private _modalService: DxModalService) {
    // setTimeout(() => this.test504(), 3000);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response, caught) => {
          if (!(response instanceof HttpErrorResponse)) {
            return throwError(response);
          }

          let extraValue: ClientHandlerExtra = new ClientHandlerExtra();
          if (response.headers.has(ClientHandlerExtra.CLIENT_HANDLER_EXTRA_HEADER)) {
            extraValue = DxObjectMapper.deserialize(response.headers.get(ClientHandlerExtra.CLIENT_HANDLER_EXTRA_HEADER), ClientHandlerExtra);
          }

          if (extraValue.ignoreGlobal) {
            return throwError(response);
          }

          switch (response.status) {
            case 400:
              if (extraValue.ignore400) {
                return throwError(response);
              }
              if (response.error && response.error.userMessage) {
                this._modalService.showError(response.error.userMessage).subscribe();
                // allowing of error handling at below level
                // return NEVER;
              }
              break;
            case 401:
              if (// window.location.href.replace(/\/$/, '') === window.location.origin ||
                  window.location.href.includes('welcome')) {
                // don't do navigate
              } else if (response.error && response.error.userMessage) {
                this._modalService.showError(response.error.userMessage).subscribe(
                  () => this._router.navigate(['welcome']).then()
                );
              } else {
                this._router.navigate(['welcome']).then();
              }
              return throwError(response);
            case 403:
              this._modalService.showError(response.message).subscribe();
              return NEVER;
            case 404:
              this._router.navigate(['error'], {
                queryParams: {
                  errorTitle: 'Такой ресурс не найден (404)',
                  errorMessage: 'Запрашиваемые вами данные отсутствуют в системе. Если вы попали на эту страницу в результате открытия ссылки, то ваш линк более не действителен'
                }});
              return NEVER;
            case 500:
              this._modalService.showError('Что-то пошло не так').subscribe();
              if (!extraValue.passBelow500) {
                return NEVER;
              }
              break;
            case 504:
            case 0:
              this._modalService.showError('Отсутствует связь с сервером').subscribe();
              return NEVER;
          }
          return throwError(response);
      })
    );
  }

  test401() {
    this._http.get('http://www.mocky.io/v2/5d89f9c93000004e00b9a5d9').subscribe(
      success => console.log('success', success),
      error => console.error('error', error),
      () => console.warn('complete')
    );
  }

  test404() {
    this._http.get('http://www.mocky.io/v2/5d89f7ed3000004b00b9a5c7').subscribe(
      success => console.log('success', success),
      error => console.error('error', error),
      () => console.warn('complete')
    );
  }

  test500() {
    this._http.get('http://www.mocky.io/v2/5d89fa2d3000005300b9a5db').subscribe(
      success => console.log('success', success),
      error => console.error('error', error),
      () => console.warn('complete')
    );
  }

  test504() {
    this._http.get('http://www.mocky.io/v2/5d8a168530000053b5b9a6e3').subscribe(
      success => console.log('success', success),
      error => console.error('error', error),
      () => console.warn('complete')
    );
  }


}
